import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Link,
  Text,
  useColorModeValue,
  SimpleGrid,
  Tabs,
  TabList,
  Tooltip,
  TabPanels,
  Tab,
  TabPanel,
  Stack,
  Alert,
  AlertIcon,
  useDisclosure,
  IconButton,
  Icon,
  Checkbox,
  HStack
} from "@chakra-ui/react";

// Custom components
import SuspiciousItem from "views/admin/suspicious/components/SuspiciousItem";
import ReportedProducts from "views/admin/suspicious/components/ReportedProducts";
import NonComplianceProducts from "views/admin/suspicious/components/NonComplianceProducts";
import NonReportableProducts from "views/admin/suspicious/components/NonReportableProducts";
import TakenDown from "views/admin/suspicious/components/TakenDown";
import NoneAbuseProducts from "views/admin/suspicious/components/NoneAbuseProducts";
import useRelevanceChanges from "hooks/useRelevanceChanges";
import Card from "components/card/Card.js";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
import { useListContext } from "../../../contexts/listContext";
import { useProductStore } from "../../../store/useProductStore"
import SheetDownload from "./components/SheetDownload";
import Loader from "../../../components/loader/Loader"
import { MdViewList, MdViewModule, MdCheckCircle, MdOutlineReportOff , MdDelete, MdShoppingCart, MdOutlineError } from "react-icons/md";
// import { Tooltip } from "react-bootstrap";

export default function Products() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  const [productsToShow, setProductsToShow] = useState(20);
  const productsPerPage = 20;

  const isAdmin = userInfo?.message?.isAdmin || false;

  const [isLoading, setIsLoading] = useState(false);
  const [insertSeller, setInsertSeller] = useState([]);
  const [whiteListSeller, setWhiteListSeller] = useState([]);
  const [reportedSeller, setReportedSeller] = useState([]);
  const [blackListSeller, setBlackListSeller] = useState([]);
  const [testProduct, setTestProduct] = useState([]);
  const [statusUpdate, setStatusUpdate] = useState(false);
  const [viewMode, setViewMode] = useState("grid");
  const [selectedIds, setSelectedIds] = useState([]);
  const { list, checkedPlatforms, abuse_type, dateFilter, platforms } =
    useListContext();
  const [abuseTypes, setAbuseTypes] = useState([]);
  const [abuseCulprit, setAbuseCulprit] = useState([]);
const {
    relevanceChanges,
    handleInsertRelevance,
    clearRelevanceChanges
} = useRelevanceChanges();  
const [sortedProducts, setSortedProducts] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [successAlert, setSuccesAlert] = useState("");
  const [failureAlert, setFailureAlert] = useState("");
  const [alertTimeout, setAlertTimeout] = useState(null);
  const [noAbuseProducts, setNoAbuseProducts] = useState([]);
  const [activeBulkStatus, setActiveBulkStatus] = useState(null);

  const { products, moveProducts, updateProducts } = useProductStore();

  const filteredProds = sortedProducts.filter(p => p.abuse_type_id !== 10 && p.abuse_type_id !== 0);
  const currentViewIds = filteredProds.slice(0, productsToShow).map(p => p.psm_id);

  const handleSelectAll = () => {
    if (selectedIds.length === currentViewIds.length) {
      // 1. Deselecting: Remove currently viewed products from the staged list
      setInsertSeller((prev) =>
        prev.filter((item) => !currentViewIds.includes(item.product.psm_id))
      );
      // 2. Clear selection UI
      setSelectedIds([]);
    } else {
      // Selecting: Just update the UI selection (Bulk actions handle the staging)
      setSelectedIds(currentViewIds);
    }
  };


  const applyBulkAction = (status) => {
    const targetProducts = filteredProds.filter((p) => selectedIds.includes(p.psm_id));

    setActiveBulkStatus(status === activeBulkStatus ? null : status); // Tracks which button is "on"

    setInsertSeller((prev) => {
      let newState = [...prev];

      targetProducts.forEach((prod) => {
        const existingIndex = newState.findIndex(
          (item) => item.product.psm_id === prod.psm_id
        );

        if (existingIndex !== -1) {
          newState[existingIndex].seller_status = status;
        } else {
          newState.push({ product: prod, seller_status: status });
        }
      });

      return newState;
    });

    handleSuccessAlert(`Staged ${selectedIds.length} items for ${status}. Click Save to confirm.`);
  };

  useEffect(() => {
    return () => {
      if (alertTimeout) {
        clearTimeout(alertTimeout);
      }
    };
  }, [alertTimeout]);

  const handleSuccessAlert = async (alertMessage) => {
    if (alertTimeout) {
      clearTimeout(alertTimeout);
    }
    setSuccesAlert(alertMessage);
    const timeout = setTimeout(() => {
      setSuccesAlert("");
    }, 5000);
    setAlertTimeout(timeout);
  };

  const handleFailureAlert = async (alertMessage) => {
    if (alertTimeout) {
      clearTimeout(alertTimeout);
    }
    setFailureAlert(alertMessage);
    const timeout = setTimeout(() => {
      setFailureAlert("");
    }, 5000);
    setAlertTimeout(timeout);
  };

  const fetchProductsByStatus = async (status) => {
    try {
      setIsLoading(true)
      const response = await fetch(
        `${backendUrl}/api/products/byStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
            status: status,
          }),
        }
      );

      const json = await response.json();

      if (response.ok) {
        if (status === "S") {
          updateProducts(json, "suspicious");
        } else if (status === "R") {
          updateProducts(json, "reported");
        } else if (status === "NC") {
          updateProducts(json, "nonCompliance");
        } else if (status === "TD") {
          updateProducts(json, "takenDown");
        }else if (status === "NR") {
          updateProducts(json, "nonReportable");
        }

      } else if (response.status === 400) {

        handleFailureAlert("Error Fetching Data");
      }
    } catch (e) {

      handleFailureAlert("Error Fetching Data");
    } finally {
      setIsLoading(false)

    }
  };

  useEffect(() => {
    if (!products["suspicious"]) {
      fetchProductsByStatus("S");
    } else {
      setSortedProducts(products["suspicious"]);
    }
  }, [userInfo?.message?.result.id]);

  const loadMore = () => {
    setProductsToShow(productsToShow + productsPerPage);
  };
  const loadLess = () => {
    setProductsToShow(productsToShow - productsPerPage);
  };

  const handleUpdateSeller = async (product, seller_status) => {
    try {
      const existingIndex = insertSeller.findIndex(
        (item) => item.product.psm_id === product.psm_id
      );

      if (existingIndex !== -1) {
        setInsertSeller((prev) => {
          const updatedSeller = [...prev];
          updatedSeller[existingIndex].seller_status = seller_status;
          return updatedSeller;
        });
      } else {
        setInsertSeller([...insertSeller, { product, seller_status }]);
      }
    } catch (err) {
      console.error("err in handleInserSeller", err);
    }
  };

  const removeFromUpdate = async (product, seller_status) => {
    setInsertSeller(
      insertSeller.filter((item) => {
        return !(item.product.psm_id === product.psm_id);
      })
    );
  };

  const getAbuseTypes = async () => {
    try {
      setIsLoading(true)

      const response = await fetch(`${backendUrl}/api/abuses/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();

      if (response.ok) {

        setAbuseTypes(json);
      } else if (response.status === 400) {

        handleFailureAlert("Error fetching Abuse Types");
      }
    } catch (e) {

      handleFailureAlert("Error fetching Abuse Types");
    } finally {
      setIsLoading(false)

    }
  };

  const handleInsertAbuse = async (product, abuse_type) => {
    try {
      const existingIndex = abuseCulprit.findIndex(
        (item) => item.product.psm_id === product.psm_id
      );

      if (existingIndex !== -1) {
        setAbuseCulprit((prev) => {
          const updated = [...prev];
          updated[existingIndex].abuse_type = abuse_type;
          return updated;
        });
      } else {
        setAbuseCulprit([...abuseCulprit, { product, abuse_type }]);
      }
      // console.log("abus culprit", abuseCulprit)
    } catch (err) {
      console.error("err in handleInserAbuse", err);
    }
  };

  const handleMoveToNoAbuse = (pd_id) => {
    setSortedProducts(prev => prev.filter(prod => prod.pd_id !== pd_id));
  };

  const syncProductUpdatesInStore = (updates = [], removeFromNoAbuse = false) => {
    useProductStore.setState((state) => {
      const suspiciousProducts = (state.products.suspicious || []).map((prod) => {
        const matchingUpdate = updates.find((item) => item.psm_id === prod.psm_id);
        return matchingUpdate ? { ...prod, abuse_type_id: matchingUpdate.abuse_type_id } : prod;
      });

      const noAbuseProducts = (state.products.noAbuse || []).filter((prod) => {
        const shouldRemove = removeFromNoAbuse
          ? updates.some((item) => item.psm_id === prod.psm_id)
          : false;

        return !shouldRemove;
      });

      return {
        products: {
          ...state.products,
          suspicious: suspiciousProducts,
          noAbuse: noAbuseProducts,
        },
      };
    });
  };

  const handleSaveChanges = async () => {
    try {
      setIsLoading(true);
            let productsToRemove = [];

              if (isAdmin) {

      // if (insertSeller.length == 0) {
      //   handleFailureAlert("select status / products");
      //   return;
      // }

      const uid = JSON.parse(localStorage.getItem("PAuser")).message.result.id;
      console.log("insertSellers", insertSeller)

      // First handle seller status updates
      const response = await fetch(
        `${backendUrl}/api/sellers/updateSellerStatus/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sellers: insertSeller,
            uid: uid,
          }),
        }
      );

      const json = await response.json();

      if (!response.ok) {

        handleFailureAlert("Error saving changes");
        alert(json.message);
        return;
      }

      // After successful API calls, move products and update UI immediately

      for (const item of insertSeller) {
        const { product, seller_status } = item;

        if (seller_status === "W") {
          const sellerProducts = products["suspicious"].filter(
            (p) => p.seller_name === product.seller_name
          );
          await moveProducts("suspicious", sellerProducts, "whitelisted");
          productsToRemove.push(...sellerProducts.map(p => p.psm_id));
        } else if (seller_status === "NC") {
          await moveProducts("suspicious", product, "nonCompliance");
          productsToRemove.push(product.psm_id);
        } else if (seller_status === "T") {
          await moveProducts("suspicious", product, "testPurchase");
          productsToRemove.push(product.psm_id);
        } else if (seller_status === "R") {
          await moveProducts("suspicious", product, "reported");
          productsToRemove.push(product.psm_id);
        } else if (seller_status === "NR") {
          await moveProducts("suspicious", product, "nonReportable");
          productsToRemove.push(product.psm_id ?? product.pd_id);
        } else if (seller_status === "X") {
          await moveProducts("suspicious", product, "toDelete");
          productsToRemove.push(product.psm_id);
        }
      }

      // Then handle abuse reports if any exist
      if (abuseCulprit.length > 0) {
        const abused = abuseCulprit.map((item) => ({
          psm_id: item.product.psm_id,
          abuse_type: item.abuse_type,
        }));

        const abuseResponse = await fetch(
          `${backendUrl}/api/products/reportAbuse/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              products: abused,
            }),
          }
        );

        if (!abuseResponse.ok) {
          setIsLoading(false)

          handleFailureAlert("Failed to save abuse reports");
          return;
        }

        const noAbuseProductsList = abuseCulprit
          .filter((item) => parseInt(item.abuse_type) === 0)
          .map((item) => ({
            ...item.product,
            abuse_type_id: 0,
          }));

        const selectedAbuseProducts = abuseCulprit
          .filter((item) => parseInt(item.abuse_type) > 0)
          .map((item) => ({
            ...item.product,
            abuse_type_id: parseInt(item.abuse_type),
          }));

        setNoAbuseProducts((prev) => {
          const existingIds = new Set(prev.map((p) => p.psm_id));
          const merged = [...prev, ...noAbuseProductsList.filter((p) => !existingIds.has(p.psm_id))];
          return merged.filter((p) => !selectedAbuseProducts.some((item) => item.psm_id === p.psm_id));
        });

        if (noAbuseProductsList.length > 0) {
          await moveProducts("suspicious", noAbuseProductsList, "noAbuse");
          productsToRemove.push(...noAbuseProductsList.map((p) => p.psm_id));
          updateProducts(noAbuseProductsList, "noAbuse");
          noAbuseProductsList.forEach((product) => {
            handleMoveToNoAbuse(product.pd_id);
          });
        }

        if (selectedAbuseProducts.length > 0) {
          syncProductUpdatesInStore(selectedAbuseProducts, true);
          setSortedProducts((prev) =>
            prev.map((prod) => {
              const updated = selectedAbuseProducts.find((item) => item.psm_id === prod.psm_id);
              return updated ? { ...prod, abuse_type_id: updated.abuse_type_id } : prod;
            })
          );
        }
      }
    }
      if (relevanceChanges.length > 0) {

    const relevanceResponse = await fetch(
        `${backendUrl}/api/products/updateRelevance`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                products: relevanceChanges, 
            }),
        }
    );

    if (!relevanceResponse.ok) {
        handleFailureAlert("Failed to update relevance.");
        return;
    }
}

      // Remove products from UI immediately (excluding those already handled by handleMoveToNoAbuse)
      setSortedProducts((prev) => {
             const filtered = prev.filter(
              (prod) => !productsToRemove.includes(prod.psm_id)
              );
          

          return filtered.map((prod) => {

              const updated = relevanceChanges.find(
                  (r) => r.pd_id === prod.pd_id
              );

              if (!updated) {
                  return prod;
              }

              return {
                  ...prod,
                  relevance: updated.relevance,
              };
          });

      });

      // Clear the update lists
      setInsertSeller([]);
      setAbuseCulprit([]);
      clearRelevanceChanges();      // Update UI state
      setStatusUpdate((prev) => !prev);

      handleSuccessAlert("Changes Saved Successfully!");
    } catch (e) {

      console.error("Error in handleSaveChanges:", e);
      handleFailureAlert("Failed to save changes. Please try again!");
    } finally {
      setIsLoading(false)
      setActiveBulkStatus(null)
      setInsertSeller([])
      setSelectedIds([])
      clearRelevanceChanges();
    }
  };

  const handleAbuseCheck = async () => {
    try {
      setIsLoading(true)

      handleSuccessAlert("Abuse Checking triggered");
      const uid = JSON.parse(localStorage.getItem("PAuser")).message.result.id;
      const resp = await fetch(`${backendUrl}/api/abuses/abuseCheck`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: uid,
        }),
      });
      const json = await resp.json();
      fetchProductsByStatus("S");
      setIsLoading(false)

      if (resp.ok) {
        handleSuccessAlert("Listings Abuse check done");
      } else {
        handleFailureAlert("Some issues occurred we're looking into it");
      }
    } catch (err) {
      setIsLoading(false)

      console.error("error in handleAbuseCheck", err);
    }
  };

  const handleSearch = async (text) => {
    try {
      if (text) {
        const filtered = products["suspicious"].filter(
          (item) =>
            item.title?.toLowerCase().includes(text?.toLowerCase()) ||
            item.keyword?.toLowerCase().includes(text?.toLowerCase()) ||
            item.seller_name?.toLowerCase().includes(text?.toLowerCase()) ||
            item.prod_code?.toLowerCase().includes(text?.toLowerCase())
        );
        setSortedProducts(filtered);
      } else {
        console.log("No search text, using context products");
        setSortedProducts(products["suspicious"] || []);
        handleFilter();
      }
    } catch (e) {
      console.error("error in search", e);
    }
  };

  const handleFilter = async () => {
    try {
      let keywordId = list.map((item) => item.id);
      let platformIds = checkedPlatforms.map((item) => item.id);
      let abuseTypeId = abuse_type.map((item) => item.id);
      let allProducts = products["suspicious"] || [];

      let filtered = allProducts;

      // Keyword filter
      if (keywordId.length > 0) {
        filtered = filtered.filter((item) =>
          keywordId.includes(item.keyword_id)
        );
      }

      // console.log("keyworlds", list)

      // Platform filter
      if (platformIds.length > 0) {
        filtered = filtered.filter((item) =>
          platformIds.includes(item.platform_id)
        );
      }

      // Abuse type filter
      if (abuseTypeId.length > 0) {
        filtered = filtered.filter((item) => {
          if (item.abuse_type_id === null || item.abuse_type_id === undefined) {
            return true; // Keep if no abuse type set
          }
          return abuseTypeId.includes(item.abuse_type_id);
        });
      }

      // Date filter
      if (dateFilter.startDate && dateFilter.endDate) {
        let startDate = new Date(dateFilter.startDate);
        let endDate = new Date(dateFilter.endDate);
        endDate.setHours(23, 59, 59, 999);

        filtered = filtered.filter((item) => {
          if (!item.date_detected) return false;
          let date = new Date(item.date_detected);
          return date >= startDate && date <= endDate;
        });
      }

      setSortedProducts(filtered);
    } catch (err) {
      console.error("Error in filtering products:", err);
      handleFailureAlert("Error in filtering products");
    }
  };

  useEffect(() => {
    handleFilter();
  }, [list, checkedPlatforms, dateFilter, products["suspicious"]]);


  const checkForStatus = async (status) => {

    if (status === "suspicious" && !products["suspicious"]) {
      fetchProductsByStatus("S");
    } else if (status === "reported" && !products["reported"]) {
      fetchProductsByStatus("R");
    } else if (status === "nonCompliance" && !products["nonCompliance"]) {
      fetchProductsByStatus("NC");
    } else if (status === "takenDown" && !products["takenDown"]) {
      fetchProductsByStatus("TD");
    } else if (status === "nonReportable" && !products["nonReportable"]) {
      fetchProductsByStatus("NR");
    } else if (status === "noAbuse" && !products["noAbuse"]) {
      // Fetch products with abuse_type_id = 0 from suspicious products or create a new API call
      const noAbuseProducts = products["suspicious"]?.filter(prod => prod.abuse_type_id === 0) || [];
      if (noAbuseProducts.length > 0) {
        updateProducts(noAbuseProducts, "noAbuse");
      }
    }
  };

  useEffect(() => {
    getAbuseTypes();
  }, []);

  return (
    <Tabs
      colorScheme="messenger"
      pt={{ base: "180px", md: "80px", xl: "80px" }}
    >
      <TabList>
        <Tab
          border="transparent"
          onClick={() => {
            checkForStatus("suspicious");
          }}
        >
          Suspicious
        </Tab>
        <Tab
          border="transparent"
          onClick={() => {
            checkForStatus("noAbuse");
          }}
        >
          No Abuse
        </Tab>
        <Tab
          border="transparent"
          onClick={() => {
            checkForStatus("reported");
          }}
        >
          Reported
        </Tab>
        <Tab
          border="transparent"
          onClick={() => {
            checkForStatus("nonCompliance");
          }}
        >
          Non Compliance
        </Tab>
        <Tab
          border="transparent"
          onClick={() => {
            checkForStatus("nonReportable");
          }}
        >
          Non Reportable
        </Tab>
        <Tab
          border="transparent"
          onClick={() => {
            checkForStatus("takenDown");
          }}
        >
          Takendown
        </Tab>
      </TabList>
      <TabPanels>
        <TabPanel >
          <Box >
            {isLoading && <Loader />}
            <Card p="0px" w="100%" >
              <Flex justify="space-between" align="center" wrap="wrap" gap={4} p={5}>
                <Text >
                  Count:{" "}
                  {
                    sortedProducts.filter(
                      (prod) =>
                        prod.abuse_type_id !== 10 && prod.abuse_type_id !== 0
                    ).length
                  }
                </Text>


                <Flex gap={2}>
                  <IconButton size="md" icon={<MdViewList />} isActive={viewMode === 'list'} onClick={() => setViewMode('list')} />
                  <IconButton size="md" icon={<MdViewModule />} isActive={viewMode === 'grid'} onClick={() => setViewMode('grid')} />

                </Flex>
              </Flex>

              {/* make this flex sticky */}
              <Box
                position="sticky"
                top="95px"
                zIndex="10"
                bg={useColorModeValue("white", "navy.800")} // Match your card's background
                boxShadow="sm" // Optional: adds a shadow when scrolling
                pb="10px"
                rounded={10}
              >

                <Flex
                  align={{ sm: "flex-start", lg: "center" }}
                  direction={{ md: "row", sm: "column" }}
                  justify="space-between"
                  w="100%"
                  px="22px"

                >
                  <SearchBar
                    m="10px"
                    borderRadius="30px"
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  {isAdmin && (
                  <Flex align="center" gap={4} >

                    {/* control buttons */}
                    <Flex align="center" gap={4} justify="end">
                      <Checkbox
                        isChecked={selectedIds.length > 0 && selectedIds.length === currentViewIds.length}
                        isIndeterminate={selectedIds.length > 0 && selectedIds.length < currentViewIds.length}
                        onChange={handleSelectAll}
                      />
                      <Text fontWeight="bold" fontSize="sm">Select All ({selectedIds.length})</Text>

                      <Flex gap={2} p={2} align="center">

                        {/* old version of line buttons */}
                        {/* <IconButton
                          size="sm"
                          variant={activeBulkStatus === 'W' ? "solid" : "ghost"}
                          colorScheme="green"
                          icon={<Icon as={MdCheckCircle} color={activeBulkStatus === 'W' ? "white" : "gray.400"} boxSize="20px" />}
                          onClick={() => applyBulkAction('W')}
                        />

                        <IconButton
                          size="sm"
                          variant={activeBulkStatus === 'T' ? "solid" : "ghost"}
                          colorScheme="blue"
                          icon={<Icon as={MdShoppingCart} color={activeBulkStatus === 'T' ? "white" : "gray.400"} boxSize="20px" />}
                          onClick={() => applyBulkAction('T')}
                        />

                        <IconButton
                          size="sm"
                          variant={activeBulkStatus === 'R' ? "solid" : "ghost"}
                          colorScheme="red"
                          icon={<Icon as={MdCancel} color={activeBulkStatus === 'R' ? "white" : "gray.400"} boxSize="20px" />}
                          onClick={() => applyBulkAction('R')}
                        /> 

                        <IconButton
                          size="sm"
                          variant={activeBulkStatus === 'X' ? "solid" : "ghost"}
                          colorScheme="red"
                          icon={<Icon as={MdDelete} color={activeBulkStatus === 'X' ? "white" : "gray.400"} boxSize="20px" />}
                          onClick={() => applyBulkAction('X')}
                        /> */}
                        <Tooltip label='Report Seller'>

                          <IconButton
                            size="sm"
                            variant={activeBulkStatus === 'R' ? "solid" : "ghost"}
                            colorScheme="red"
                            icon={<Icon as={MdOutlineError} color={activeBulkStatus === 'R' ? "white" : "gray.400"} boxSize="20px" />}
                            onClick={() => applyBulkAction('R')}
                          />
                        </Tooltip>

                        <Tooltip label="Whitelist">
                          <IconButton
                            size="sm"
                            variant={activeBulkStatus === 'W' ? "solid" : "ghost"}
                            colorScheme="green"
                            icon={<Icon as={MdCheckCircle} color={activeBulkStatus === 'W' ? "white" : "gray.400"} boxSize="20px" />}
                            onClick={() => applyBulkAction('W')}
                          />
                        </Tooltip>

                        <Tooltip label='Test Purchase'>

                          <IconButton
                            size="sm"
                            variant={activeBulkStatus === 'T' ? "solid" : "ghost"}
                            colorScheme="blue"
                            icon={<Icon as={MdShoppingCart} color={activeBulkStatus === 'T' ? "white" : "gray.400"} boxSize="20px" />}
                            onClick={() => applyBulkAction('T')}
                          />
                        </Tooltip>


                        <Tooltip label='Delete Product'>

                          <IconButton
                            size="sm"
                            variant={activeBulkStatus === 'X' ? "solid" : "ghost"}
                            colorScheme="red"
                            icon={<Icon as={MdDelete} color={activeBulkStatus === 'X' ? "white" : "gray.400"} boxSize="20px" />}
                            onClick={() => applyBulkAction('X')}
                          />
                        </Tooltip>
                        <Tooltip label='Non Reportable'>

                          <IconButton
                            size="sm"
                            variant={activeBulkStatus === 'NR' ? "solid" : "ghost"}
                            colorScheme="orange"
                            icon={<Icon as={MdOutlineReportOff } color={activeBulkStatus === 'NR' ? "white" : "gray.400"} boxSize="20px" />}
                            onClick={() => applyBulkAction('NR')}
                          />
                        </Tooltip>
                      </Flex>

                    </Flex>
                    {/* )} */}

                    {/* {isAdmin && ( */}

                    {/* final save changes buttons */}
                    <Flex flexDir="row" alignSelf="right" display={{ base: "flex-start", lg: "center" }}
                    >
                      {isAdmin && (
                        <HStack>
                          <Button
                            variant="action"
                            mr="5px"
                            onClick={() => {
                              handleAbuseCheck();
                            }}
                          >
                            Check Abuse
                          </Button>

                          <Button variant="action" mr="5px" onClick={onOpen}>
                            Product Sheet
                          </Button>
                          <SheetDownload
                            isOpen={isOpen}
                            onClose={onClose}
                            products={insertSeller}
                            platforms={platforms}
                          />
                        </HStack>
                      )}
                     
                    </Flex>
                    
                    {/* )} */}
                  </Flex>)}
                       {(isAdmin || relevanceChanges.length > 0) && (

                      <Button
                        variant="action"
                        ml="5px"
                        onClick={() => {
                          handleSaveChanges();
                        }}
                      >
                        Save Changes
                      </Button>
                          )}

                </Flex>
              </Box>

              <SimpleGrid columns={viewMode === 'grid' ? { base: 1, md: 3, xl: 4 } : 1} spacing={3}>

                {sortedProducts
                  .filter(
                    (prod) =>
                      prod.abuse_type_id !== 10 && prod.abuse_type_id !== 0
                  )
                  .slice(0, productsToShow)
                  .map((prod, index) => (
                    <SuspiciousItem
                      key={prod.psm_id ?? prod.pd_id}
                      index={index}
                      product={prod}
                      viewMode={viewMode}
                      isSelected={selectedIds.includes(prod.psm_id)}
                      onSelect={() => setSelectedIds(prev => prev.includes(prod.psm_id) ? prev.filter(id => id !== prod.psm_id) : [...prev, prod.psm_id])}
                      handleInsertSeller={handleUpdateSeller}
                      handleInsertRelevance={handleInsertRelevance}
                      removeFromInsert={removeFromUpdate}
                      statusUpdate={statusUpdate}
                      setStatusUpdate={setStatusUpdate}
                      moveProducts={moveProducts}
                      abuseTypes={abuseTypes}
                      handleInsertAbuse={handleInsertAbuse}
                      setNoAbuseProducts={setNoAbuseProducts}
                      isAdmin={isAdmin}

                    />
                  ))}
              </SimpleGrid>
            </Card>

            <Stack spacing={3} position="fixed" right="10px" bottom="2vh">
              {successAlert !== "" && (
                <Alert status="success" variant="left-accent" w="40vw">
                  <AlertIcon />
                  {successAlert}
                </Alert>
              )}
              {failureAlert !== "" && (
                <Alert status="error" variant="left-accent" w="40vw">
                  <AlertIcon />
                  {failureAlert}
                </Alert>
              )}
            </Stack>

            <Link>
              <Text
                color={textColor}
                fontSize="l"
                fontWeight="500"
                onClick={() => loadLess()}
                r="0"
                position="absolute"
                right={{ base: "10%", md: "15%", sm: "30%" }}
                textDecoration="underline"
              >
                Show less...
              </Text>
            </Link>
            <Link>
              <Text
                color={textColor}
                fontSize="l"
                fontWeight="500"
                onClick={() => loadMore()}
                r="0"
                position="absolute"
                right={{ base: "2%", md: "5%" }}
                textDecoration="underline"
              >
                Show more...
              </Text>
            </Link>
          </Box>
        </TabPanel>
        <TabPanel>

          <NoneAbuseProducts
            userId={userInfo?.message?.result.id}
            suspiciousProducts={products["suspicious"] || []}
            noAbuseProducts={noAbuseProducts}
            fetchProductsByStatus={fetchProductsByStatus}
            abuseTypes={abuseTypes}
            handleInsertAbuse={handleInsertAbuse}
            moveProducts={moveProducts}
            isAdmin={isAdmin}
            setNoAbuseProducts={setNoAbuseProducts}
            isLoading={isLoading}


          />
        </TabPanel>
        <TabPanel id="reported">
          <ReportedProducts
            userId={userInfo?.message?.result.id}
            reportedProducts={products["reported"] || []}
            fetchProductsByStatus={fetchProductsByStatus}
            moveProducts={moveProducts}
            isAdmin={isAdmin}
            isLoading={isLoading}
          />
        </TabPanel>

        <TabPanel>
          <NonComplianceProducts
            userId={userInfo?.message?.result.id}
            nonComplianceProducts={products["nonCompliance"] || []}
            fetchProductsByStatus={fetchProductsByStatus}
            moveProducts={moveProducts}
            isAdmin={isAdmin}
            isLoading={isLoading}
          />
        </TabPanel>
        <TabPanel>
          <NonReportableProducts
            userId={userInfo?.message?.result.id}
            suspiciousProducts={products["suspicious"] || []}
            noAbuseProducts={noAbuseProducts}
            fetchProductsByStatus={fetchProductsByStatus}
            abuseTypes={abuseTypes}
            handleInsertAbuse={handleInsertAbuse}
            moveProducts={moveProducts}
            isAdmin={isAdmin}
            setNoAbuseProducts={setNoAbuseProducts}
            isLoading={isLoading}
          />
        </TabPanel>

        <TabPanel>
          <TakenDown
            userId={userInfo?.message?.result.id}
            takenDownProducts={products["takenDown"] || []}
            fetchProductsByStatus={fetchProductsByStatus}
            moveProducts={moveProducts}
            isAdmin={isAdmin}
            isLoading={isLoading}

          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}
